module.exports = __webpack_public_path__ + "e23de0b8c53747f387f7723676adafcc.svg";